<template>
  <div class="load">
    <div class="card white reverse">
      <div class="col ml-3 mr-3 center-items-y">
        <div class="box mt-2 mb-2 row center-items">
          <qrcode-stream
            :camera="camera"
            @init="onInit"
            @decode="onDecode"
            class="center-text col center-items"
          >
            <transition name="background-popup" mode="out-in">
              <div class="col center-items">
                <img
                  v-if="loading"
                  class="img-size"
                  src="https://res.cloudinary.com/complex-software/image/upload/v1593601612/Springboard/fertzmu02kvisiu9llth.png"
                />
                <div v-else-if="error != ''" class="col center-items">
                  <span class="mdi mdi-alert title-2 mb-1"></span>
                  <div class="ml-3 mr-3 subtitle medium">{{error}}</div>
                </div>
              </div>
            </transition>
          </qrcode-stream>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { QrcodeStream } from "vue-qrcode-reader";
export default {
  components: {
    QrcodeStream
  },
  data: () => ({
    loading: true,
    error: "",
    camera: "auto"
  }),
  methods: {
    async onInit(promise) {
      this.loading = true;
      try {
        await promise;
      } catch (error) {
        if (error.name === "NotAllowedError") {
          this.error = "Debe otorgar permiso de acceso a la cámara";
        } else if (error.name === "NotFoundError") {
          this.error = "No hay cámara en este dispositivo";
        } else if (error.name === "NotSupportedError") {
          this.error = "Se requiere contexto seguro (HTTPS)";
        } else if (error.name === "NotReadableError") {
          this.error = "¿La cámara ya está en uso?";
        } else if (error.name === "OverconstrainedError") {
          this.error = "Las cámaras instaladas no son adecuadas";
        } else if (error.name === "StreamApiNotSupportedError") {
          this.error = "Stream API no es compatible con este dispositivo";
        }
      } finally {
        this.loading = false;
      }
    },
    onDecode(decodedString) {
      const validation = JSON.parse(decodedString);
      if (Number.isInteger(validation[1])) {
        this.camera = "off";
        axios
          .get(this.$store.getters.endpoint + "confirmToQR", {
            params: {
              license: this.$store.getters.profile.license,
              reserve: validation[0]
            }
          })
          .then(
            response => {
              if (response.status == 200) {
                this.$store.commit("closed");
                setTimeout(() => {
                  this.$store.commit("dataTicket", response.data);
                }, 500);
              } else {
                store.commit("messages", {
                  visible: true,
                  icon: response.data.icon,
                  text: response.data.text,
                  color: response.data.color
                });
              }
            },
            error => {
              store.commit("messages", {
                visible: true,
                icon: "mdi-alert-circle",
                text: error.message,
                color: "red"
              });
            }
          );
      }
    }
  }
};
</script>
<style scoped>
.img-size {
  height: 200px;
  width: 200px;
}
.load {
  position: fixed;
  z-index: 500;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
}
.card {
  position: absolute;
  top: 0;
  width: 300px;
  /* height: 0px; */
  overflow: hidden;
  border-radius: 0 0 20px 20px;
}
.button-width {
  width: 150px;
}
.box {
  width: 220px;
  height: 220px;
  overflow: hidden;
}
</style>